var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',[_c('h1',{attrs:{"data-h1":"404"}},[_vm._v("\n      404\n    ")]),_vm._v(" "),_c('p',{attrs:{"data-p":"NOT FOUND"}},[_vm._v("\n      NOT FOUND\n    ")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ce05b3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/404.vue
// module id = 611
// module chunks = 0